import './assets/styles/globals.scss';
import './assets/styles/typography.css';
import { HashRouter } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import Home from './components/Embed/HomePage';
import { StyleContextProvider } from './context/StyleContext';
import { AppContextProvider } from './context/AppContext';
import { Content } from 'packages/radiant-react/layout';
import { authenticate } from './utils/auth';
import { useEffect } from 'react';
import { getReleaseVariables, isAiMode } from './utils/variablesService';
import { useVariable } from './context/ThemeContext';
import { AiModeHeader } from './components/AiMode/Header/index';

export default function App() {
  const { dispatch } = useVariable();

  useEffect(() => {
    authenticate();
    getReleaseVariables().then((releaseVariables) => {
      dispatch({ type: 'updatedState', value: releaseVariables });
    });
  }, []);

  return (
    <div className="app">
      <Analytics />
      <HashRouter>
        <StyleContextProvider>
          <AppContextProvider>
            <Content className="content" disableOverlayScroll>
              {isAiMode() && <AiModeHeader />}
              <Home />
            </Content>
          </AppContextProvider>
        </StyleContextProvider>
      </HashRouter>
    </div>
  );
}
